import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { dashboardActions } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';

export const openModalDocumentType = ['doc_kp', 'doc_contract', 'doc_your_contract', 'doc_your_proposal'];
export const downloadDocumentType = ['doc_reconciliation', 'doc_order', 'doc_act'];
interface Props {
    setErrorStatus: React.Dispatch<React.SetStateAction<boolean>>;
}
export const useDocumentSelect = ({ setErrorStatus }: Props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const allDocumentsTypes = [
        { value: 'doc_kp', title: t('useDocumentSelect.return.allDocumentsTypes.doc_kp') },
        {
            value: 'doc_your_proposal',
            title: t('useDocumentSelect.return.allDocumentsTypes.doc_your_proposal'),
        },
        {
            value: 'doc_contract',
            title: t('useDocumentSelect.return.allDocumentsTypes.doc_contract'),
        },
        {
            value: 'doc_your_contract',
            title: t('useDocumentSelect.return.allDocumentsTypes.doc_your_contract'),
        },
        {
            value: 'doc_reconciliation',
            title: t('useDocumentSelect.return.allDocumentsTypes.doc_reconciliation'),
        },
        {
            value: 'doc_order',
            title: t('useDocumentSelect.return.allDocumentsTypes.doc_order'),
        },
        {
            value: 'doc_act',
            title: t('useDocumentSelect.return.allDocumentsTypes.doc_act'),
        },
    ];

    // @ts-ignore
    const { documents } = useSelector((state) => state.dashboardReducer);
    const [selectedDocument, setSelectedDocument] = useState({ value: null, title: '' });
    const [accessesDocument, setAccessesDocument] = useState<{ value: string; title: string }[]>(
        []
    );
    const onSelect = (value: string) => {
        setErrorStatus(false);
        const selectedDocument = accessesDocument.find((el) => el.value === value);
        if (selectedDocument) {
            dispatch(dashboardActions.changeCurrentDocument(selectedDocument.value));
            setSelectedDocument(selectedDocument);
        }
    };

    useEffect(() => {
        setAccessesDocument(
            allDocumentsTypes
                // doc_order (Приказ об ответственных) и doc_act (Акт скрытых работ) доступны только на RU-локали
                .filter((doc) => LOCALE === 'ru' || !['doc_order', 'doc_act'].includes(doc.value))
                .filter((doc) => {
                    if (doc.value === 'doc_your_contract') {
                        return documents.is_having_contract_document;
                    } else if (doc.value === 'doc_your_proposal') {
                        return documents.is_having_proposal_document;
                    }
                    return true;
                })
        );
    }, []);
    return { documents: accessesDocument, onSelect, selectedDocument };
};
